import React, { FC } from 'react';

import { Stack, Text } from '@chakra-ui/react';

import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';

import { customTheme } from '../../../../../theme';

export const LearnMoreAboutVulnerabilityScan: FC = () => {
  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="vulnerability_scan"
      headerTitle="Ariksa Vulnerability Scanning  "
      body={
        <Stack spacing={6}>
          <Stack spacing={3}>
            <Text fontWeight={600} fontSize="xl">
              Ariksa Outpost For Vulnerability Management
            </Text>
            <Text>
              Ariksa Outpost for Vulnerabilities provides agentless scanning to
              identify software vulnerabilities present in your workloads and
              images. Outpost automatically scans virtual machines, containers,
              container images, serverless functions and machine images for
              software vulnerabilities, and overlays its unique risk context for
              every resource to automatically prioritize resources for patching.
              Ariksa assesses exploitability in a customized way for resources
              in your environment as part of a multi-layered assessment. This
              eliminates generalized vulnerabilities that either don’t affect
              your environment or do not apply to specific resources that don’t
              fully meet all criteria for exploitability. This significantly
              reducing operational overhead to patch and maintain a secure
              posture for your workloads.
            </Text>
          </Stack>
          <Text
            fontWeight={600}
            fontSize="xl"
            color={customTheme.colors.gray['250']}
          >
            Deployment
          </Text>
          <Text>
            Ariksa currently provides two modes for scanning vulnerabilities.
            They are simply different in operations, but not in how your data or
            disks are treated for the purposes of security and privacy.
          </Text>
          <Text>
            For AWS, we currently perform all scans from our account, while
            fully keeping all data in your environment, This eliminates
            lifecycle management for Ariksa Outposts that may otherwise be
            deployed in your accounts. To scan for software vulnerabilities in
            OS images and libraries, you can selectively enable regions for
            cloud resources that require vulnerability management. You may
            enable only for business-critical accounts like those used for
            production. Ariksa automatically scans all relevant resources in the
            regions you enable for an account without any further action. When
            you add an account for vulnerability scan, Ariksa creates a
            right-sized, trusted cross-account role with the appropriate
            permissions to scan your workloads. All your data and disks remain
            in your cloud environment. Ariksa does not copy any data to its
            environment. It simply attaches to the workloads to scan for
            vulnerabilities.
          </Text>
          <Text>
            For GCP and Azure, you will need to deploy Ariksa Outpost for
            Vulnerabilities in your project or subscription. Outposts deployed
            in your project or subscription have exactly the same permissioning
            as the ones deployed by Ariksa.
          </Text>
        </Stack>
      }
    />
  );
};
